
export const initialState = {
  sending: false,
  isSent: false
};

export const getSending = state => state.contact.sending;
export const getIsSent = state => state.contact.isSent;

